<div class="tooltip">
  <div class="tooltip-title">
    Санкт-Петербургская Международная Товарно-сырьевая Биржа
  </div>
  <div *ngIf="text" class="tooltip-text">
    {{ text }}
  </div>
</div>
